import { render, staticRenderFns } from "./PostOwner.vue?vue&type=template&id=967c665a&scoped=true&"
import script from "./PostOwner.vue?vue&type=script&lang=js&"
export * from "./PostOwner.vue?vue&type=script&lang=js&"
import style0 from "./PostOwner.vue?vue&type=style&index=0&id=967c665a&lang=scss&scoped=true&"
import style1 from "./PostOwner.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "967c665a",
  null
  
)

export default component.exports